import PropTypes from 'prop-types'

// Internal components
import FileTypeIcon from '../FileTypeIcon/FileTypeIcon'

const DownloadList = ({ files }) => {
  return (
    <div className="DownloadList">
      {files.map(({ fileTitle, fileDescription, file }, index) => {
        if (file?.[0]) {
          let fileType = file[0]?.url.split('.').pop()
          fileType = fileType === 'jpeg' ? 'jpg' : fileType
          fileType = fileType === 'docx' ? 'doc' : fileType
          fileType = fileType === 'xlsx' ? 'xls' : fileType

          const fileSize = `${(file?.[0]?.size / 1000000).toFixed(1)} mb`

          return (
            <a key={`DownloadList-item-${index}`} className="DownloadList-item" href={file[0]?.url}>
              <div className="DownloadList-itemInfo">
                <h3 className="DownloadList-itemTitle">{fileTitle}</h3>
                <div className="DownloadList-itemSizeWrapper">
                  <span className="DownloadList-itemSize">{fileSize}</span>
                  {fileType && <FileTypeIcon type={fileType} />}
                </div>
              </div>
              {fileDescription && <p className="DownloadList-itemDescription">{fileDescription}</p>}
            </a>
          )
        } else return ''
      })}
    </div>
  )
}

DownloadList.propTypes = {
  files: PropTypes.array.isRequired
}

export default DownloadList
